import { FOCUSABLE_SELECTOR } from './constants';

const DIALOG_SELECTOR = '[role="dialog"]';

export const getFocusableElements = (root, selector = FOCUSABLE_SELECTOR) => (
  [...root.querySelectorAll(selector)].filter((element) => element.getClientRects().length > 0)
);

export const trapTabFocus = (event, container) => {
  const focusable = getFocusableElements(container);

  if (!focusable.length) {
    return;
  }

  const firstFocusable = focusable[0];
  const lastFocusable = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === firstFocusable) {
    event.preventDefault();
    lastFocusable.focus();
  } else if (!event.shiftKey && document.activeElement === lastFocusable) {
    event.preventDefault();
    firstFocusable.focus();
  }
};

export const focusInside = (overlay) => {
  const dialog = overlay.matches(DIALOG_SELECTOR) ? overlay : overlay.querySelector(DIALOG_SELECTOR);
  const target = dialog || getFocusableElements(overlay)[0] || overlay;

  if (target === dialog || target === overlay) {
    target.setAttribute('tabindex', '-1');
  }

  target.focus();
};
